import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchYearList } from "./helpAndAssistantApi";

export interface YearListState {
  yearlist: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: YearListState = {
    yearlist: [],
  status: "idle",
};

export const GetYearList = createAsyncThunk(
  "YearList/fetchYear",
  async () => {
    const response = await fetchYearList();
    return response;
  }
);

export const YearListSlice = createSlice({
  name: "YearList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetYearList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetYearList.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetYearList.fulfilled, (state, action) => {
        state.status = "idle";
        state.yearlist = action.payload;
      });
  },
});

export const {} = YearListSlice.actions;

export const selectYearList = (state: RootState) => {
  return state.YearList.yearlist;
};

export default YearListSlice.reducer;
